/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Authentication Page Layout
 *
 * - NEW FILE
 * - MISSION: To create a dedicated layout for authentication pages (like
 * Login and Sign Up) that ensures they have a consistent Header and Footer
 * while allowing the main content to fill the screen.
 *
 * - FEATURES:
 * 1.  Structural Consistency: Imports and renders the standard `Header` and
 * `Footer` components, ensuring a consistent brand experience even on
 * auth pages.
 * 2.  Flexible Content Area: Uses React Router's `<Outlet />` component to
 * render the specific page content (e.g., the Login form).
 * 3.  Full-Height Content: A flexbox container (`min-h-screen flex-col`)
 * ensures that the layout occupies the full viewport height, with the
 * main content area (`flex-grow`) expanding to fill the space between
 * the Header and Footer.
 */
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { FocusRestorer } from '../shared/FocusRestorer';

const AuthLayout = () => {
  return (
    <div className="relative bg-background text-text min-h-screen flex flex-col">
      <FocusRestorer />
      <Header />
      <main className="flex-grow flex flex-col">
        <Outlet />
      </main>
      <Footer cookieBannerHeight={0} />
    </div>
  );
};

export default AuthLayout;
